import { Button, Input, Typography, message } from "antd";
import { useState } from "react";
import { AuthService } from "../../services/AuthService";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Card";
import Goback from "../../components/Goback";
import { Brand } from "../../models/brand";
const { TextArea } = Input;

const { Text } = Typography;

const NewBrand = () => {

    const navigate = useNavigate();

    const [brand, setBrand] = useState<Brand>({
        brandId: 0,
        name: null,
        description: null
    })

    const [loading, setLoading] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();


    const saveBrand = async () => {
        setLoading(true);
        let { name, description } = brand;
        if (!name || !description) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            setLoading(false);
            return;
        }
        let res = await AuthService.createBrand(brand)
        if (res) {

            messageApi.open({
                type: 'success',
                content: 'Vlera u ruajt me sukses',
            });
            setTimeout(() => {
                setLoading(false);
                navigate(`/brands`);
            }, 1000);
        }

        console.log("save brand", res);
    }


    return (
        <div className="container">
            {contextHolder}
            <div className="row">
                <div className="col-12">
                    <Goback />
                </div>
                <div className="col-8">
                    <Card title="Add new brand">
                        <form action="">
                            <div className="row">
                                <div className="col-12">
                                    <Text>Emri i brendit *</Text>
                                    <Input value={brand?.name} onChange={(e) => setBrand({ ...brand, name: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <Text>Pershkrimi *</Text>
                                    <TextArea rows={4} value={brand?.description} onChange={(e) => setBrand({ ...brand, description: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end">
                                        <Button type="primary" loading={loading} disabled={loading} onClick={saveBrand}>Ruaj brendin</Button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default NewBrand;